/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance } from 'mobx-state-tree';

const { model, boolean } = types;

export const appMenuStore = model('appMenuStore', {
  isOpen: boolean,
})
  .views((self) => ({}))
  .volatile(() => ({}))
  .actions((self) => ({
    openAppMenu: (): void => {
      self.isOpen = true;
    },
    closeAppMenu: (): void => {
      self.isOpen = false;
    },
  }));

export type IAppMenuStore = Instance<typeof appMenuStore>;
